export default __webpack_public_path__ + "static/media/admob-reward.a7c8fed8.png";